export const NOTIFICATION_RESET = "NOTIFICATION_RESET" as const;
export const NOTIFICATION_ALL_SET = "NOTIFICATION_ALL_SET" as const;
export const LANDING_MESSAGE_SET = "LANDING_MESSAGE_SET" as const;
export const LANDING_TWEET_SET = "LANDING_TWEET_SET" as const;
export const NOTIFICATION_ALERT_SET = "NOTIFICATION_ALERT_SET" as const;
export const NOTIFICATION_UNREAD_SET = "NOTIFICATION_UNREAD_SET" as const;
export const NOTIFICATION_UPLOAD_SET = "NOTIFICATION_UPLOAD_SET" as const;
export const POSTING_STATUS_SET = "POSTING_STATUS_SET" as const;
